import React from 'react';
export function FeaturedRecognitionSection() {
  return <section className="section-padding bg-black border-y border-white/5" data-id="element-49">
      <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-50">
        <h2 className="text-sm font-bold text-[#D4AF37] uppercase tracking-widest mb-4" data-id="element-51">
          Industry Recognition
        </h2>
        <h3 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-52">
          Featured By Leading Platforms
        </h3>
        <p className="text-lg text-gray-400" data-id="element-53">
          Pankaj Maurya recognized as a top Shopify expert by industry leaders
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-54">
        <a href="https://www.omnisend.com/blog/shopify-experts/" target="_blank" rel="noopener noreferrer" className="glass-card p-8 border-white/10 hover:border-[#D4AF37]/30 transition-all duration-300 group" data-id="element-55">
          <div className="flex items-start gap-4" data-id="element-56">
            <div className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center border border-white/10 shrink-0" data-id="element-57">
              <span className="text-2xl" data-id="element-58">🏆</span>
            </div>
            <div data-id="element-59">
              <h4 className="text-xl font-bold text-white mb-2 group-hover:text-[#D4AF37] transition-colors" data-id="element-60">
                Featured by Omnisend
              </h4>
              <p className="text-gray-400 text-sm mb-3" data-id="element-61">
                Recognized among top Shopify experts for exceptional ecommerce
                development and design expertise
              </p>
              <span className="text-[#D4AF37] text-sm font-medium inline-flex items-center gap-1" data-id="element-62">
                Read Article →
              </span>
            </div>
          </div>
        </a>
        <a href="https://ecomposer.io/blogs/ecommerce/best-shopify-web-designers" target="_blank" rel="noopener noreferrer" className="glass-card p-8 border-white/10 hover:border-[#D4AF37]/30 transition-all duration-300 group" data-id="element-63">
          <div className="flex items-start gap-4" data-id="element-64">
            <div className="w-12 h-12 rounded-xl bg-white/5 flex items-center justify-center border border-white/10 shrink-0" data-id="element-65">
              <span className="text-2xl" data-id="element-66">⭐</span>
            </div>
            <div data-id="element-67">
              <h4 className="text-xl font-bold text-white mb-2 group-hover:text-[#D4AF37] transition-colors" data-id="element-68">
                Featured by EComposer
              </h4>
              <p className="text-gray-400 text-sm mb-3" data-id="element-69">
                Listed among the best Shopify web designers for creating
                high-converting, beautifully designed stores
              </p>
              <span className="text-[#D4AF37] text-sm font-medium inline-flex items-center gap-1" data-id="element-70">
                Read Article →
              </span>
            </div>
          </div>
        </a>
      </div>
    </section>;
}